import { Component, Input } from '@angular/core';
import { RowmenuComponent } from '../rowmenu/rowmenu.component';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { CrossmatchService } from '../../../services/crossmatch.service';
import { NotifyService } from '../../../common/notify/notify.service';
import { Crossmatch } from '../../../interfaces/crossmatch';
import { CrossmatchType } from '../../crossmatch/add-crossmatch/add-crossmatch.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-excluded-list',
  imports: [RowmenuComponent, MatListModule, CommonModule, MatProgressSpinnerModule],
  providers: [NotifyService],
  templateUrl: './excluded-list.component.html',
  styleUrl: './excluded-list.component.scss'
})
export class ExcludedListComponent {
  @Input() excludedCombinations?: Crossmatch[];
  @Input() busy?: boolean;
  @Input() totalRows?: number;
  @Input() highlightText?: string;
  @Input() type?: CrossmatchType;

  selectedExcluded?: Crossmatch;

  constructor(
    private readonly crossmatchService: CrossmatchService,
    private readonly notify: NotifyService
  ) {}

  ngOnInit() {
    this.crossmatchService.excludedCombinations$.subscribe((combinations) => {
      this.excludedCombinations = combinations;
    });
  }

  key(_index: number, crossmatch: Crossmatch) {
    return this.type + '-' + crossmatch.id;
  }

  async handleAction(action: { event: string; param: Crossmatch }) {
    const comb = action.param;

    if (action.event === 'delete' && comb.id) {
      this.crossmatchService.deleteCrossmatch(comb.id).subscribe({
        next: (response) => {
          console.log('Crossmatch deleted:', response);
          this.notify.withAutodismiss(`Deleted excluded Crossmatch [${comb.recipientEnis}, ${comb.donorEnis}]`);
          this.crossmatchService.removeExcludedCombination(comb.id);
        },
        error: (err) => {
          this.notify.withAutodismiss(`Couldn't delete excluded Crossmatch [${comb.recipientEnis}, ${comb.donorEnis}] ${err}`);
        }
      });
    }
  }

  showExcludedDetails(excluded: Crossmatch): void {
    if (this.selectedExcluded && this.selectedExcluded.id === excluded.id) {
      this.selectedExcluded = undefined;
    } else {
      this.selectedExcluded = excluded;
    }
  }

  closeExcludedDetails(): void {
    this.selectedExcluded = undefined;
  }
}
